const LAST_ORG = 'espm-last-org';
const LAST_TEAM_BY_ORG = 'espm-last-team-by-org';
const LAST_MODE = 'espm-mode';
const SCOUT_FOCUS = 'espm-scout-focus';

export const getScoutFocus = (): boolean => {
  try {
    return localStorage.getItem(SCOUT_FOCUS) === '1';
  } catch {
    return false;
  }
};

export const setScoutFocus = (focus: boolean) => {
  try {
    localStorage.setItem(SCOUT_FOCUS, focus ? '1' : '0');
  } catch {
    // noop — localStorage unavailable
  }
};

export type StoredMode = 'plan' | 'season';

export const getLastMode = (): StoredMode | null => {
  try {
    const value = localStorage.getItem(LAST_MODE);
    return value === 'plan' || value === 'season' ? value : null;
  } catch {
    return null;
  }
};

export const setLastMode = (mode: StoredMode) => {
  try {
    localStorage.setItem(LAST_MODE, mode);
  } catch {
    // noop — localStorage unavailable
  }
};

export const getLastOrgId = (): string | null => {
  try {
    return localStorage.getItem(LAST_ORG);
  } catch {
    return null;
  }
};

export const setLastOrgId = (id: string) => {
  try {
    localStorage.setItem(LAST_ORG, id);
  } catch {
    // noop — localStorage unavailable
  }
};

export const getLastTeamIdForOrg = (orgId: string): string | null => {
  try {
    const raw = localStorage.getItem(LAST_TEAM_BY_ORG);
    if (!raw) return null;
    const map = JSON.parse(raw) as Record<string, string>;
    return map?.[orgId] ?? null;
  } catch {
    return null;
  }
};

const readTeamMap = (): Record<string, string> => {
  try {
    const raw = localStorage.getItem(LAST_TEAM_BY_ORG);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, string>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const setLastTeamIdForOrg = (orgId: string, teamId: string) => {
  try {
    const map = readTeamMap();
    map[orgId] = teamId;
    localStorage.setItem(LAST_TEAM_BY_ORG, JSON.stringify(map));
  } catch {
    // noop — localStorage unavailable
  }
};
